export default function ulsterReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_ULSTER":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
